import React from 'react';
import { Shield } from 'lucide-react';
import { Section } from './Shared';
export const Guarantee = () => <Section className="max-w-3xl" data-id="element-80">
    <div className="glass-panel p-8 md:p-12 rounded-3xl text-center border-brand-aqua/40 bg-white/85 shadow-sm" data-id="element-81">
      <Shield className="w-14 h-14 md:w-16 md:h-16 text-brand-aqua mx-auto mb-6" data-id="element-82" />
      <h2 className="text-xl md:text-3xl font-display font-bold mb-4 text-brand-darkGreen" data-id="element-83">
        🛡️ GARANTÍA DE 7 DÍAS
      </h2>
      <p className="text-brand-text mb-4 text-base md:text-lg" data-id="element-84">
        Entrás. Descargás todo el material. Lo revisás. Lo aplicás. Y comprobás
        por vos mismo si realmente puede ayudarte.
      </p>
      <p className="text-brand-text mb-6 text-base md:text-lg" data-id="element-85">
        Si durante los primeros 7 días sentís que no era lo que esperabas,
        simplemente escribinos y te devolvemos el 100% de tu dinero. Sin
        preguntas. Sin explicaciones. Sin formularios.
      </p>
      <p className="font-medium text-brand-aqua text-sm md:text-base" data-id="element-86">
        ✅ Riesgo para vos: ninguno. ✅ Riesgo para nosotros: todo.
      </p>
    </div>
  </Section>;
export const Footer = () => <footer className="bg-brand-darkGreen text-white/85 py-12 border-t border-brand-gold/20" data-id="element-87">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-88">
      <div className="mb-8" data-id="element-89">
        <h3 className="font-display font-bold text-2xl text-brand-goldLight mb-2" data-id="element-90">
          🌿 LUMEN AKASHA™
        </h3>
        <p className="text-white/75" data-id="element-91">
          El sistema profesional para terapeutas holísticos.
        </p>
        <p className="text-white/75 mt-2" data-id="element-92">
          Porque ayudar personas es importante. Pero primero necesitan
          encontrarte.
        </p>
      </div>

      <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-8 mb-12 text-sm" data-id="element-93">
        <a href="mailto:soportelumenakasha@gmail.com" className="hover:text-brand-goldLight transition-colors" data-id="element-94">
          📧 soportelumenakasha@gmail.com
        </a>
        <a href="https://instagram.com/lumen.akasha" className="hover:text-brand-goldLight transition-colors" data-id="element-95">
          📲 @lumen.akasha
        </a>
        <span className="text-white/85" data-id="element-96">🟢 WhatsApp: 11 5339-9780</span>
        <a href="https://www.lumenakasha.com" className="hover:text-brand-goldLight transition-colors" data-id="element-97">
          🌐 lumenakasha.com
        </a>
      </div>

      <div className="text-xs text-white/50 space-y-2" data-id="element-98">
        <p data-id="element-99">
          © LUMEN AKASHA™ — Todos los derechos reservados. Prohibida su
          reproducción o distribución sin autorización expresa.
        </p>
        <p data-id="element-100">Ley 25.326 — Protección de Datos Personales — República Argentina</p>
      </div>
    </div>
  </footer>;